export default __webpack_public_path__ + "static/media/CashPmtPrev.8eadfbd7.jpeg";